// extracted by mini-css-extract-plugin
module.exports = {"promo-banner":"PromoBanner_promo-banner__jJ_9n","singleMessage":"PromoBanner_singleMessage__Z0x6P"};